export default "__VITE_ASSET__Duh66kwH__"